import { ErroApi } from './auth/cliente-api';

/**
 * 401 e 403 nao se resolvem tentando de novo.
 *
 * O 401 pede entrar de novo — e o cliente da API ja renovou o token por conta antes
 * de desistir. O 403 pede outro caminho: a resposta seria identica na segunda vez, e
 * o unico efeito de insistir seria dobrar a espera antes de a tela dizer o que houve.
 *
 * Mesma logica de `modulos/operacao/comum/dados.ts`, aqui em `nucleo/` porque
 * `dados.ts` de modulos fora de `operacao/` (ex.: `admin/parametros/*`) tambem
 * precisam dela — evita a escolha entre depender de um modulo irmao ou repetir a
 * funcao seis vezes.
 */
export function naoInsistirEmRecusa(tentativas: number, erro: unknown): boolean {
  if (erro instanceof ErroApi && (erro.pedeEntrarDeNovo || erro.pedeOutroCaminho)) {
    return false;
  }
  return tentativas < 1;
}
